import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ConfirmationService, ConfirmationOptions, ConfirmationResult } from '../../services/confirmation.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent implements OnInit, OnDestroy {
  isOpen = false;
  options: ConfirmationOptions | null = null;
  private currentResultSubject: Subject<ConfirmationResult> | null = null;
  private destroy$ = new Subject<void>();

  constructor(private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.confirmationService.confirmation$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ options, result }) => {
        this.options = options;
        this.currentResultSubject = result;
        this.isOpen = true;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onConfirm(): void {
    if (this.currentResultSubject) {
      this.currentResultSubject.next({ confirmed: true });
      this.currentResultSubject.complete();
    }
    this.close();
  }

  onCancel(): void {
    if (this.currentResultSubject) {
      this.currentResultSubject.next({ confirmed: false });
      this.currentResultSubject.complete();
    }
    this.close();
  }

  onClose(): void {
    this.onCancel();
  }

  private close(): void {
    this.isOpen = false;
    this.options = null;
    this.currentResultSubject = null;
  }

  getIconClass(): string {
    if (!this.options) return 'fas fa-question-circle';
    
    switch (this.options.type) {
      case 'danger':
        return 'fas fa-exclamation-triangle';
      case 'warning':
        return 'fas fa-exclamation-circle';
      case 'info':
        return 'fas fa-info-circle';
      case 'question':
      default:
        return 'fas fa-question-circle';
    }
  }

  getHeaderClass(): string {
    if (!this.options) return 'modal-header-default';
    
    switch (this.options.type) {
      case 'danger':
        return 'modal-header-danger';
      case 'warning':
        return 'modal-header-warning';
      case 'info':
        return 'modal-header-info';
      case 'question':
      default:
        return 'modal-header-default';
    }
  }
}
